
import { publicJsapiTicket } from "@/common/api.js";

const Share = {
    registerWeixinShare(url, shareUrl){
        publicJsapiTicket({ url }).then((res) => {
            console.log('分享地址:' + shareUrl)
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
                appId: res.appId || "wxc1ca3bce1945503b", //必填，公众号的唯一标识
                nonceStr: res.noncestr, // 必填，生成签名的随机串
                timestamp: res.timestamp, // 必填，生成签名的时间戳
                signature: res.signature, //// 必填，签名
                openTagList: ["wx-open-launch-weapp"], // 可选，需要使用的开放标签列表
                jsApiList: [
                "chooseImage",
                "getLocation",
                "updateAppMessageShareData",
                "updateTimelineShareData",
                ], // 必填，需要使用的JS接口列表
            });
    
            wx.ready(function () {
                console.log("wx config ready");
                let iconUrl = "https://static.cias.cn/wxapp/vas/static/h5/icon_share@2x.png";
                wx.updateAppMessageShareData({
                    title: "抢福利咯！代为年检【取送车服务】免费领！", // 分享标题
                    desc: "广州、深圳、合肥的车主有福啦！现有代办年检服务大放送~", // 分享描述
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: iconUrl, // 分享图标
                    success: function () {
                        // 设置成功
                        console.log("分享给朋友，设置成功");
                    },
                });
    
                wx.updateTimelineShareData({
                    title: "抢福利咯！代为年检【取送车服务】免费领！", // 分享标题
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: iconUrl, // 分享图标
                    success: function () {
                        // 设置成功
                        console.log("分享到朋友圈，设置成功");
                    },
                });
            });
            wx.error(function (err) {
                console.log("wx config error");
            });
        });
        
    },

};

export default Share;